import React, { Component } from 'react'
//import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import { Icon, Popover, Tooltip } from 'antd'
//import CustomFooter from '../../login/CustomFooter'
//import SubjectHistogram from '../../admin/SubjectHistogram'
//import SupportPieChartTiers from '../../admin/SupportPieChartTiers'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
//import Empty from '../../customcomponents/Empty'
//import { getIDFromURL } from '../.././Util'
//import { Row, Col } from 'antd'
//const { Content } = Layout

class PacingGuideDraggableStandard extends Component {
    state = {

    }

    componentDidMount() {

    }

    render() {
        return (
            <div className='w-100'>
                <div className='font-bold font-16 mt-2 flex flex-v-center w-100'>
                    <div>
                        {this.props.item.standard}
                    </div>
                    {this.props.item.isPriority ?
                        <div className='flex flex-v-center font-14 ml-1 background-purple font-fff pl-1 pr-1 pt-05 pb-05 br-15'>
                            <Icon type='pushpin' className='mr-05' />
                            <div>Priority</div>
                        </div> : ''}
                </div>
                {this.props.pacingGuideBaseProps &&
                    this.props.pacingGuideBaseProps.pacingGuideStats &&
                    this.props.pacingGuideBaseProps.standardCategory &&
                    this.props.pacingGuideBaseProps.standardName ?
                    (() => {
                        const stats = this.props.pacingGuideBaseProps.pacingGuideStats;
                        const cat = this.props.pacingGuideBaseProps.standardCategory;
                        const name = this.props.pacingGuideBaseProps.standardName;
                        const week = String(this.props.week);
                        const standard = this.props.item.standard;
                        const currentWeek = this.props.pacingGuideBaseProps.currentWeek;
                        const isFuture = Number(this.props.week) > currentWeek;
                        const weekData = stats.guides &&
                            stats.guides[cat] &&
                            stats.guides[cat][name] &&
                            stats.guides[cat][name][week];
                        if (!weekData) return null;
                        const entry = weekData.find(e => e.standard === standard);
                        if (!entry) return null;
                        const action = entry.action;
                        const level = stats.type === 'district' ? 'district' : 'school';
                        const base = { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', borderRadius: 6, fontWeight: 800, fontSize: 13, whiteSpace: 'nowrap', marginTop: 4, marginBottom: 4, cursor: 'default' };
                        const tooltips = {
                            assess: `Assign a quiz for this standard.`,
                            reteach: `Reteach this standard and assign another quiz.`,
                            review: `Review this standard to reinforce understanding.`,
                            on_track: `Keep up the great work!`,
                            upcoming: `This standard is scheduled for a future week.`,
                        };
                        let span_value = <span></span>;
                        let tooltip = '';
                        if (isFuture) {
                            span_value = <span style={{ ...base, backgroundColor: '#f8fafc', color: '#a1a1aa', border: '2px solid #d4d4d8' }}><Icon type="clock-circle" style={{ fontSize: 12 }} /> Upcoming</span>;
                            tooltip = tooltips.upcoming;
                        }
                        else if (action === 'assess') {
                            span_value = <span style={{ ...base, backgroundColor: '#f1f5f9', color: '#475569', border: '2px solid #94a3b8' }}><Icon type="edit" style={{ fontSize: 12 }} /> Assess</span>;
                            tooltip = tooltips.assess;
                        }
                        else if (action === 'reteach') {
                            span_value = <span style={{ ...base, backgroundColor: '#fef3c7', color: '#92400e', border: '2px solid #f59e0b' }}><Icon type="reload" style={{ fontSize: 12 }} /> Reteach</span>;
                            tooltip = tooltips.reteach;
                        }
                        else if (action === 'review') {
                            span_value = <span style={{ ...base, backgroundColor: '#dbeafe', color: '#1e40af', border: '2px solid #3b82f6' }}><Icon type="eye" style={{ fontSize: 12 }} /> Review</span>;
                            tooltip = tooltips.review;
                        }
                        else {
                            span_value = <span style={{ ...base, backgroundColor: '#d1fae5', color: '#065f46', border: '2px solid #10b981' }}><Icon type="check-circle" style={{ fontSize: 12 }} /> On Track</span>;
                            tooltip = tooltips.on_track;
                        }
                        return <Popover
                            overlayClassName='popover-no-pointer-events'
                            title={<div className='flex flex-v-center w-100 popover-no-pointer-events'
                                style={{ maxWidth: '300px' }}>
                                <div className='font-bold font-16'>{standard}</div>
                                <div className='ml-auto'>{span_value}</div>
                            </div>}
                            content={<div className='popover-no-pointer-events font-16'
                                style={{ maxWidth: '300px' }}>
                                {tooltip}</div>}
                            placement="top">
                            {span_value}
                        </Popover>
                    })()
                    : ''}
                {this.props.scheduledNum &&
                    this.props.scheduledNum > 0 ?
                    <div className='font-16 text-success'>
                        <Icon type='check' className='mr-05' />
                        <span>Scheduled: {this.props.scheduledNum} {this.props.scheduledNum === 1 ? 'time' : 'times'}</span>
                    </div>
                    : ''}
                {this.props.hasOwnProperty('displayTitle') && !this.props.displayTitle ?
                    <div className={'font-16 overflow-hidden relative' +
                        (this.props.isToday ? ' text-blur-light-blue-new' : ' text-blur')
                    }
                        style={{
                            maxHeight: '75px',
                        }}>
                        {this.props.item.title}</div> :
                    <div className='font-16'>{this.props.item.title}</div>}
            </div>
        )
    }
}

export default PacingGuideDraggableStandard
